import { useIntl } from 'react-intl'
import { Tag } from 'ui'
import { AdvancedConfigProps } from '.'
import { messages } from '../../messages'

export function EqualsTag(props: AdvancedConfigProps) {
  const {
    config: { equals },
  } = props
  const { $t } = useIntl()
  const {
    benefit: { advanced },
  } = messages

  return <Tag>{$t(advanced.equals, { value: equals })}</Tag>
}
